__turbopack_context__.v({
  "page": "PDFPageTemplate-module__FLfLyq__page",
  "viewArea": "PDFPageTemplate-module__FLfLyq__viewArea",
});
